import React from "react";
import {NavLink} from "react-router-dom";

import NewsMenuType from "enum/NewsMenuType";
import Router from "router/router";
import NavBlock from "./partials/nav-block/NavBlock";
import Service from "./partials/service/Service";
import * as css from "./css/nav";
import useMyStores from "hooks/useMyStores";
import {observer} from "mobx-react";

function Nav(props) {

    const {user, login} = useMyStores()

    const {className} = props;

    return (
        <css.Nav className={className}>
            <css.NavItem>
                <css.NavLink
                    as={NavLink}
                    to={`${Router.News.realPath}?menuType=${NewsMenuType.VIDEO}`}
                >
                    视频中心
                </css.NavLink>
            </css.NavItem>
            <css.NavItem>
                <css.NavLink
                    onClick={(e) => {
                        e.preventDefault();

                        if (!user.token) {
                            login.show = true;
                        } else {
                            window.open(
                                Router.basename + Router.User.path + "?currentIndex=4"
                            );
                        }
                    }}
                >
                    我的浏览
                </css.NavLink>
            </css.NavItem>
            <css.NavItem>
                <css.NavLink
                    onClick={(e) => {
                        e.preventDefault();

                        if (!user.token) {
                            login.show = true;
                        } else {
                            window.open(
                                Router.basename + Router.User.path + "?currentIndex=2"
                            );
                        }
                    }}
                >
                    我的收藏
                </css.NavLink>
            </css.NavItem>
            <css.NavItem className="nav">
                <css.NavLink>
                    客户服务
                    <img
                        src={require("./img/arrow-down.png")}
                        alt=""
                        className="arrow-down"
                    />
                </css.NavLink>
                <css.ServiceNavBlock as={Service}/>
            </css.NavItem>
            <css.NavItem className="nav">
                <css.NavLink>
                    网站导航
                    <img
                        src={require("./img/arrow-down.png")}
                        alt=""
                        className="arrow-down"
                    />
                </css.NavLink>

                <css.NavBlock as={NavBlock}/>
            </css.NavItem>
        </css.Nav>
    );
}

export default observer(Nav)
